import i18next from 'i18next'
import {PeriodType} from '@/stores/date-picker/models/PeriodType'

export const getDefaultRangePresets = (): Record<string, PeriodType> => ({
    [i18next.t('RangePicker.presets.today')]: PeriodType.Day,
    [i18next.t('RangePicker.presets.yesterday')]: PeriodType.Yesterday,
    [i18next.t('RangePicker.presets.thisWeek')]: PeriodType.Week,
    [i18next.t('RangePicker.presets.last7Days')]: PeriodType.Last7Days,
    [i18next.t('RangePicker.presets.thisMonth')]: PeriodType.Month,
    [i18next.t('RangePicker.presets.last30Days')]: PeriodType.Last30Days,
    [i18next.t('RangePicker.presets.last60Days')]: PeriodType.Last60Days,
    [i18next.t('RangePicker.presets.last90Days')]: PeriodType.Last90Days,
    [i18next.t('RangePicker.presets.thisYear')]: PeriodType.Year,
    [i18next.t('RangePicker.presets.last12Month')]: PeriodType.Last12Months
})

export const isOctoberRestrictionEnabled = false
